import { SetVariableActionSettings } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/SetVariableActionSettings';
import { ActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/ActionController';
import { ActionFeatures } from '../ActionFeatures';
import { VARIABLE_VALIDATION_REGEX } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/Validator';
import '../Actions.scss';
export class SetVariableActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', 'CurrentApplicationService', '$translate', '$rootScope', 'UndoRedoService', 'state', '$timeout', '$scope', 'typeOfAction'];
    constructor(close, action, $onStateChanged, CurrentApplicationService, $translate, $rootScope, UndoRedoService, state, $timeout, $scope, typeOfAction) {
        super(close, action, $onStateChanged, UndoRedoService, state, $rootScope, $scope, typeOfAction);
        this.CurrentApplicationService = CurrentApplicationService;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.$timeout = $timeout;
        this.isEditing = false;
        this.variableName = '{{context.variableName}}';
        this.init();
    }
    async init() {
        this.isActionConditionEnabled = await ActionFeatures.isActionConditionEnabled();
        this.application = await this.CurrentApplicationService.fetchApplicationByStateParams();
        this.$timeout(() => {
            this.setVariableForm.variable.$setDirty();
            this.checkValidVariableName();
            this.checkValidInputs();
        });
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
    }
    startEditing() {
        const input = document.getElementById('set-variable-title');
        if (input) {
            input.focus();
        }
    }
    checkValidInputs() {
        if (!this.action.settings) {
            this.save();
        }
    }
    checkValidVariableName() {
        if (!this.checkVariableRegex()) {
            this.setVariableForm.variable.$invalid = true;
            this.setVariableForm.variable.$valid = false;
        }
    }
    checkVariable() {
        this.checkValidVariableName();
        this.save();
    }
    checkVariableRegex() {
        return (this.action.settings.variable &&
            this.action.settings.variable.match(VARIABLE_VALIDATION_REGEX));
    }
    onBlur() {
        this.isEditing = false;
        if (this.$title.length === 0) {
            this.$title = this.$translate.instant('builder-tabs-actions.setVariable.title');
            this.save();
        }
    }
    create() {
        return new SetVariableActionSettings();
    }
}
SetVariableActionController.$inject = ['close', 'action', '$onStateChanged', 'CurrentApplicationService', '$translate', '$rootScope', 'UndoRedoService', 'state', '$timeout', '$scope', 'typeOfAction'];
